import { useState, useEffect, useRef, useMemo, useCallback } from "react";
import * as d3 from "d3";

const TOPO_URL =
  "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const RAW = `004|Afghanistan|Kabul|af,008|Albania|Tirana|al,012|Algeria|Algiers|dz,020|Andorra|Andorra la Vella|ad,024|Angola|Luanda|ao,028|Antigua and Barbuda|St. John's|ag,032|Argentina|Buenos Aires|ar,051|Armenia|Yerevan|am,036|Australia|Canberra|au,040|Austria|Vienna|at,031|Azerbaijan|Baku|az,044|Bahamas|Nassau|bs,048|Bahrain|Manama|bh,050|Bangladesh|Dhaka|bd,052|Barbados|Bridgetown|bb,056|Belgium|Brussels|be,084|Belize|Belmopan|bz,204|Benin|Porto-Novo|bj,064|Bhutan|Thimphu|bt,068|Bolivia|Sucre|bo,070|Bosnia and Herzegovina|Sarajevo|ba,072|Botswana|Gaborone|bw,076|Brazil|Brasilia|br,096|Brunei|Bandar Seri Begawan|bn,100|Bulgaria|Sofia|bg,854|Burkina Faso|Ouagadougou|bf,108|Burundi|Gitega|bi,132|Cape Verde|Praia|cv,116|Cambodia|Phnom Penh|kh,120|Cameroon|Yaounde|cm,124|Canada|Ottawa|ca,140|Central African Republic|Bangui|cf,148|Chad|N'Djamena|td,152|Chile|Santiago|cl,156|China|Beijing|cn,170|Colombia|Bogota|co,174|Comoros|Moroni|km,178|Republic of the Congo|Brazzaville|cg,180|Democratic Republic of the Congo|Kinshasa|cd,188|Costa Rica|San Jose|cr,384|Ivory Coast|Yamoussoukro|ci,191|Croatia|Zagreb|hr,192|Cuba|Havana|cu,196|Cyprus|Nicosia|cy,203|Czech Republic|Prague|cz,208|Denmark|Copenhagen|dk,262|Djibouti|Djibouti|dj,212|Dominica|Roseau|dm,214|Dominican Republic|Santo Domingo|do,218|Ecuador|Quito|ec,818|Egypt|Cairo|eg,222|El Salvador|San Salvador|sv,226|Equatorial Guinea|Malabo|gq,232|Eritrea|Asmara|er,233|Estonia|Tallinn|ee,231|Ethiopia|Addis Ababa|et,242|Fiji|Suva|fj,246|Finland|Helsinki|fi,250|France|Paris|fr,266|Gabon|Libreville|ga,270|Gambia|Banjul|gm,268|Georgia|Tbilisi|ge,276|Germany|Berlin|de,288|Ghana|Accra|gh,300|Greece|Athens|gr,308|Grenada|St. George's|gd,320|Guatemala|Guatemala City|gt,324|Guinea|Conakry|gn,624|Guinea-Bissau|Bissau|gw,328|Guyana|Georgetown|gy,332|Haiti|Port-au-Prince|ht,340|Honduras|Tegucigalpa|hn,348|Hungary|Budapest|hu,352|Iceland|Reykjavik|is,356|India|New Delhi|in,360|Indonesia|Jakarta|id,364|Iran|Tehran|ir,368|Iraq|Baghdad|iq,372|Ireland|Dublin|ie,376|Israel|Jerusalem|il,380|Italy|Rome|it,388|Jamaica|Kingston|jm,392|Japan|Tokyo|jp,400|Jordan|Amman|jo,398|Kazakhstan|Astana|kz,404|Kenya|Nairobi|ke,296|Kiribati|Tarawa|ki,408|North Korea|Pyongyang|kp,410|South Korea|Seoul|kr,414|Kuwait|Kuwait City|kw,417|Kyrgyzstan|Bishkek|kg,418|Laos|Vientiane|la,428|Latvia|Riga|lv,422|Lebanon|Beirut|lb,426|Lesotho|Maseru|ls,430|Liberia|Monrovia|lr,434|Libya|Tripoli|ly,438|Liechtenstein|Vaduz|li,440|Lithuania|Vilnius|lt,442|Luxembourg|Luxembourg City|lu,807|North Macedonia|Skopje|mk,450|Madagascar|Antananarivo|mg,454|Malawi|Lilongwe|mw,458|Malaysia|Kuala Lumpur|my,462|Maldives|Male|mv,466|Mali|Bamako|ml,470|Malta|Valletta|mt,584|Marshall Islands|Majuro|mh,478|Mauritania|Nouakchott|mr,480|Mauritius|Port Louis|mu,484|Mexico|Mexico City|mx,583|Micronesia|Palikir|fm,492|Monaco|Monaco|mc,496|Mongolia|Ulaanbaatar|mn,499|Montenegro|Podgorica|me,504|Morocco|Rabat|ma,508|Mozambique|Maputo|mz,104|Myanmar|Naypyidaw|mm,516|Namibia|Windhoek|na,520|Nauru|Yaren|nr,524|Nepal|Kathmandu|np,528|Netherlands|Amsterdam|nl,554|New Zealand|Wellington|nz,558|Nicaragua|Managua|ni,562|Niger|Niamey|ne,566|Nigeria|Abuja|ng,578|Norway|Oslo|no,512|Oman|Muscat|om,586|Pakistan|Islamabad|pk,585|Palau|Ngerulmud|pw,275|Palestine|Ramallah|ps,591|Panama|Panama City|pa,598|Papua New Guinea|Port Moresby|pg,600|Paraguay|Asuncion|py,604|Peru|Lima|pe,608|Philippines|Manila|ph,616|Poland|Warsaw|pl,620|Portugal|Lisbon|pt,634|Qatar|Doha|qa,642|Romania|Bucharest|ro,643|Russia|Moscow|ru,646|Rwanda|Kigali|rw,659|Saint Kitts and Nevis|Basseterre|kn,662|Saint Lucia|Castries|lc,670|Saint Vincent and the Grenadines|Kingstown|vc,882|Samoa|Apia|ws,674|San Marino|San Marino|sm,678|Sao Tome and Principe|Sao Tome|st,682|Saudi Arabia|Riyadh|sa,686|Senegal|Dakar|sn,688|Serbia|Belgrade|rs,690|Seychelles|Victoria|sc,694|Sierra Leone|Freetown|sl,702|Singapore|Singapore|sg,703|Slovakia|Bratislava|sk,705|Slovenia|Ljubljana|si,090|Solomon Islands|Honiara|sb,706|Somalia|Mogadishu|so,710|South Africa|Pretoria|za,728|South Sudan|Juba|ss,724|Spain|Madrid|es,144|Sri Lanka|Sri Jayawardenepura Kotte|lk,729|Sudan|Khartoum|sd,740|Suriname|Paramaribo|sr,748|Eswatini|Mbabane|sz,752|Sweden|Stockholm|se,756|Switzerland|Bern|ch,760|Syria|Damascus|sy,158|Taiwan|Taipei|tw,762|Tajikistan|Dushanbe|tj,834|Tanzania|Dodoma|tz,764|Thailand|Bangkok|th,626|Timor-Leste|Dili|tl,768|Togo|Lome|tg,776|Tonga|Nuku'alofa|to,780|Trinidad and Tobago|Port of Spain|tt,788|Tunisia|Tunis|tn,792|Turkey|Ankara|tr,795|Turkmenistan|Ashgabat|tm,798|Tuvalu|Funafuti|tv,800|Uganda|Kampala|ug,804|Ukraine|Kyiv|ua,784|United Arab Emirates|Abu Dhabi|ae,826|United Kingdom|London|gb,840|United States|Washington D.C.|us,858|Uruguay|Montevideo|uy,860|Uzbekistan|Tashkent|uz,548|Vanuatu|Port Vila|vu,336|Vatican City|Vatican City|va,862|Venezuela|Caracas|ve,704|Vietnam|Hanoi|vn,887|Yemen|Sanaa|ye,894|Zambia|Lusaka|zm,716|Zimbabwe|Harare|zw`;

const ES_RAW = `004|Afganistan|Kabul,008|Albania|Tirana,012|Argelia|Argel,020|Andorra|Andorra la Vella,024|Angola|Luanda,028|Antigua y Barbuda|St. John's,032|Argentina|Buenos Aires,051|Armenia|Erevan,036|Australia|Canberra,040|Austria|Viena,031|Azerbaiyan|Baku,044|Bahamas|Nassau,048|Barein|Manama,050|Bangladesh|Daca,052|Barbados|Bridgetown,056|Belgica|Bruselas,084|Belice|Belmopan,204|Benin|Porto Novo,064|Butan|Timbu,068|Bolivia|Sucre,070|Bosnia y Herzegovina|Sarajevo,072|Botsuana|Gaborone,076|Brasil|Brasilia,096|Brunei|Bandar Seri Begawan,100|Bulgaria|Sofia,854|Burkina Faso|Uagadugu,108|Burundi|Gitega,132|Cabo Verde|Praia,116|Camboya|Nom Pen,120|Camerun|Yaunde,124|Canada|Ottawa,140|Republica Centroafricana|Bangui,148|Chad|Yamena,152|Chile|Santiago,156|China|Pekin,170|Colombia|Bogota,174|Comoras|Moroni,178|Republica del Congo|Brazzaville,180|Republica Democratica del Congo|Kinshasa,188|Costa Rica|San Jose,384|Costa de Marfil|Yamusukro,191|Croacia|Zagreb,192|Cuba|La Habana,196|Chipre|Nicosia,203|Republica Checa|Praga,208|Dinamarca|Copenhague,262|Yibuti|Yibuti,212|Dominica|Roseau,214|Republica Dominicana|Santo Domingo,218|Ecuador|Quito,818|Egipto|El Cairo,222|El Salvador|San Salvador,226|Guinea Ecuatorial|Malabo,232|Eritrea|Asmara,233|Estonia|Tallin,231|Etiopia|Adis Abeba,242|Fiyi|Suva,246|Finlandia|Helsinki,250|Francia|Paris,266|Gabon|Libreville,270|Gambia|Banjul,268|Georgia|Tiflis,276|Alemania|Berlin,288|Ghana|Acra,300|Grecia|Atenas,308|Granada|St. George's,320|Guatemala|Ciudad de Guatemala,324|Guinea|Conakri,624|Guinea-Bisau|Bisau,328|Guyana|Georgetown,332|Haiti|Puerto Principe,340|Honduras|Tegucigalpa,348|Hungria|Budapest,352|Islandia|Reikiavik,356|India|Nueva Delhi,360|Indonesia|Yakarta,364|Iran|Teheran,368|Irak|Bagdad,372|Irlanda|Dublin,376|Israel|Jerusalen,380|Italia|Roma,388|Jamaica|Kingston,392|Japon|Tokio,400|Jordania|Aman,398|Kazajistan|Astana,404|Kenia|Nairobi,296|Kiribati|Tarawa,408|Corea del Norte|Pionyang,410|Corea del Sur|Seul,414|Kuwait|Ciudad de Kuwait,417|Kirguistan|Biskek,418|Laos|Vientian,428|Letonia|Riga,422|Libano|Beirut,426|Lesoto|Maseru,430|Liberia|Monrovia,434|Libia|Tripoli,438|Liechtenstein|Vaduz,440|Lituania|Vilna,442|Luxemburgo|Luxemburgo,807|Macedonia del Norte|Skopie,450|Madagascar|Antananarivo,454|Malaui|Lilongue,458|Malasia|Kuala Lumpur,462|Maldivas|Male,466|Mali|Bamako,470|Malta|La Valeta,584|Islas Marshall|Majuro,478|Mauritania|Nuakchot,480|Mauricio|Port Louis,484|Mexico|Ciudad de Mexico,583|Micronesia|Palikir,492|Monaco|Monaco,496|Mongolia|Ulan Bator,499|Montenegro|Podgorica,504|Marruecos|Rabat,508|Mozambique|Maputo,104|Myanmar|Naypyidaw,516|Namibia|Windhoek,520|Nauru|Yaren,524|Nepal|Katmandu,528|Paises Bajos|Amsterdam,554|Nueva Zelanda|Wellington,558|Nicaragua|Managua,562|Niger|Niamey,566|Nigeria|Abuya,578|Noruega|Oslo,512|Oman|Mascate,586|Pakistan|Islamabad,585|Palaos|Ngerulmud,275|Palestina|Ramala,591|Panama|Ciudad de Panama,598|Papua Nueva Guinea|Port Moresby,600|Paraguay|Asuncion,604|Peru|Lima,608|Filipinas|Manila,616|Polonia|Varsovia,620|Portugal|Lisboa,634|Catar|Doha,642|Rumania|Bucarest,643|Rusia|Moscu,646|Ruanda|Kigali,659|San Cristobal y Nieves|Basseterre,662|Santa Lucia|Castries,670|San Vicente y las Granadinas|Kingstown,882|Samoa|Apia,674|San Marino|San Marino,678|Santo Tome y Principe|Santo Tome,682|Arabia Saudita|Riad,686|Senegal|Dakar,688|Serbia|Belgrado,690|Seychelles|Victoria,694|Sierra Leona|Freetown,702|Singapur|Singapur,703|Eslovaquia|Bratislava,705|Eslovenia|Liubliana,090|Islas Salomon|Honiara,706|Somalia|Mogadiscio,710|Sudafrica|Pretoria,728|Sudan del Sur|Yuba,724|Espana|Madrid,144|Sri Lanka|Sri Jayawardenepura Kotte,729|Sudan|Jartum,740|Surinam|Paramaribo,748|Esuatini|Mbabane,752|Suecia|Estocolmo,756|Suiza|Berna,760|Siria|Damasco,158|Taiwan|Taipei,762|Tayikistan|Dusambe,834|Tanzania|Dodoma,764|Tailandia|Bangkok,626|Timor Oriental|Dili,768|Togo|Lome,776|Tonga|Nukualofa,780|Trinidad y Tobago|Puerto Espana,788|Tunez|Tunez,792|Turquia|Ankara,795|Turkmenistan|Asjabad,798|Tuvalu|Funafuti,800|Uganda|Kampala,804|Ucrania|Kiev,784|Emiratos Arabes Unidos|Abu Dabi,826|Reino Unido|Londres,840|Estados Unidos|Washington D.C.,858|Uruguay|Montevideo,860|Uzbekistan|Taskent,548|Vanuatu|Port Vila,336|Ciudad del Vaticano|Ciudad del Vaticano,862|Venezuela|Caracas,704|Vietnam|Hanoi,887|Yemen|Sana,894|Zambia|Lusaka,716|Zimbabue|Harare`;

const COUNTRIES = {};
RAW.split(",").forEach((e) => {
  const [id, n, c, i] = e.split("|");
  COUNTRIES[id] = { name: n, capital: c, iso2: i };
});
const ES = {};
ES_RAW.split(",").forEach((e) => {
  const [id, n, c] = e.split("|");
  ES[id] = { name: n, capital: c };
});

const norm = (s) =>
  s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const EN_AL = {};
Object.entries(COUNTRIES).forEach(([id, c]) => {
  EN_AL[c.name.toLowerCase()] = id;
  EN_AL[norm(c.name)] = id;
});
const EN_EX = {
  usa: "840",
  us: "840",
  "united states of america": "840",
  america: "840",
  uk: "826",
  "great britain": "826",
  britain: "826",
  england: "826",
  "russian federation": "643",
  "republic of korea": "410",
  korea: "410",
  dprk: "408",
  persia: "364",
  congo: "178",
  "dr congo": "180",
  drc: "180",
  "cote d'ivoire": "384",
  czechia: "203",
  uae: "784",
  emirates: "784",
  holland: "528",
  "the netherlands": "528",
  burma: "104",
  "east timor": "626",
  "timor leste": "626",
  swaziland: "748",
  macedonia: "807",
  bosnia: "070",
  trinidad: "780",
  png: "598",
  car: "140",
  nz: "554",
  ceylon: "144",
  "republic of china": "158",
  "cabo verde": "132",
  "cape verde": "132",
  vatican: "336",
  "holy see": "336",
  "st kitts": "659",
  "st lucia": "662",
  "st vincent": "670",
  "ivory coast": "384",
  "the bahamas": "044",
  fsm: "583",
};
Object.entries(EN_EX).forEach(([k, v]) => {
  EN_AL[k] = v;
  EN_AL[norm(k)] = v;
});
const ES_AL = {};
Object.entries(ES).forEach(([id, c]) => {
  ES_AL[c.name.toLowerCase()] = id;
  ES_AL[norm(c.name)] = id;
});
const ES_EX = {
  eeuu: "840",
  "ee.uu.": "840",
  "ee uu": "840",
  "gran bretana": "826",
  inglaterra: "826",
  holanda: "528",
  birmania: "104",
  suazilandia: "748",
  vaticano: "336",
  "santa sede": "336",
  palestina: "275",
  "san cristobal": "659",
};
Object.entries(ES_EX).forEach(([k, v]) => {
  ES_AL[k] = v;
  ES_AL[norm(k)] = v;
});

function decodeTopo(topo, o) {
  const tf = topo.transform,
    a = topo.arcs;
  const d = a.map((arc) => {
    let x = 0,
      y = 0;
    return arc.map(([dx, dy]) => {
      x += dx;
      y += dy;
      return [
        x * tf.scale[0] + tf.translate[0],
        y * tf.scale[1] + tf.translate[1],
      ];
    });
  });
  const ar = (i) => (i >= 0 ? d[i] : d[~i].slice().reverse());
  const rn = (ids) =>
    ids.reduce((c, i) => c.concat(c.length ? ar(i).slice(1) : ar(i)), []);
  const gm = (g) => {
    if (g.type === "Polygon")
      return { type: "Polygon", coordinates: g.arcs.map(rn) };
    if (g.type === "MultiPolygon")
      return {
        type: "MultiPolygon",
        coordinates: g.arcs.map((p) => p.map(rn)),
      };
    return g;
  };
  return {
    type: "FeatureCollection",
    features: topo.objects[o].geometries.map((g) => ({
      type: "Feature",
      id: g.id,
      properties: g.properties || {},
      geometry: gm(g),
    })),
  };
}

const TIMERS = [
  { en: "5 min", es: "5 min", v: 300 },
  { en: "10 min", es: "10 min", v: 600 },
  { en: "15 min", es: "15 min", v: 900 },
  { en: "20 min", es: "20 min", v: 1200 },
  { en: "30 min", es: "30 min", v: 1800 },
  { en: "No limit", es: "Sin limite", v: 0 },
];
const fmt = (s) => {
  if (s <= 0) return "∞";
  const m = Math.floor(s / 60);
  return `${m}:${(s % 60).toString().padStart(2, "0")}`;
};

const W = 860,
  H = 440;

const T = {
  en: {
    title: "GeoMaster",
    sub: "Test your world geography knowledge",
    countries: "Name All Countries",
    countriesD: "Type every country to fill the map green",
    capitals: "Capital Cities",
    capitalsD: "Name the capital of each highlighted country",
    flags: "Flag Quiz",
    flagsD: "Identify which country a flag belongs to",
    timer: "Timer Setting",
    disc: "countries to discover",
    ph: "Type a country name...",
    capPh: "Type the capital city...",
    hint: "Hint",
    give: "Give Up",
    menu: "Menu",
    again: "Play Again",
    back: "Back to Menu",
    streak: "streak",
    dup: "Already guessed!",
    ok: "Correct!",
    res: "Results",
    up: "Time's up!",
    wow: "Incredible! You got them all!",
    named: "You named",
    of: "of",
    cof: "correct out of",
    miss: "Show missed countries",
    wcap: "What is the capital of",
    wflag: "WHICH COUNTRY DOES THIS FLAG BELONG TO?",
    fres: "Flag Quiz Results",
    ans: "The answer was",
    was: "It was",
    lng: "ES",
    skip: "Skip",
    zoomOut: "Zoom out",
  },
  es: {
    title: "GeoMaster",
    sub: "Pon a prueba tus conocimientos de geografia",
    countries: "Nombra Todos los Paises",
    countriesD: "Escribe cada pais para pintarlo de verde",
    capitals: "Capitales del Mundo",
    capitalsD: "Nombra la capital de cada pais resaltado",
    flags: "Quiz de Banderas",
    flagsD: "Identifica a que pais pertenece cada bandera",
    timer: "Temporizador",
    disc: "paises por descubrir",
    ph: "Escribe un nombre de pais...",
    capPh: "Escribe la capital...",
    hint: "Pista",
    give: "Rendirse",
    menu: "Menu",
    again: "Jugar de Nuevo",
    back: "Volver al Menu",
    streak: "racha",
    dup: "Ya lo adivinaste!",
    ok: "Correcto!",
    res: "Resultados",
    up: "Se acabo el tiempo!",
    wow: "Increible! Los tienes todos!",
    named: "Nombraste",
    of: "de",
    cof: "correctas de",
    miss: "Mostrar paises faltantes",
    wcap: "Cual es la capital de",
    wflag: "A QUE PAIS PERTENECE ESTA BANDERA?",
    fres: "Resultados del Quiz",
    ans: "La respuesta era",
    was: "Era",
    lng: "EN",
    skip: "Saltar",
    zoomOut: "Alejar",
  },
};

const total = Object.keys(COUNTRIES).length;

export default function GeoQuiz() {
  const [lang, setLang] = useState("en");
  const [scr, setScr] = useState("menu");
  const [geo, setGeo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [guessed, setGuessed] = useState(new Set());
  const [inp, setInp] = useState("");
  const [tDur, setTDur] = useState(900);
  const [tLeft, setTLeft] = useState(900);
  const [run, setRun] = useState(false);
  const [last, setLast] = useState(null);
  const [streak, setStreak] = useState(0);
  const [hints, setHints] = useState(3);
  const [flash, setFlash] = useState(null);
  const [cQ, setCQ] = useState(null);
  const [cS, setCS] = useState({ c: 0, t: 0 });
  const [cPool, setCPool] = useState([]);
  const [cFb, setCFb] = useState(null);
  const [fQ, setFQ] = useState(null);
  const [fOpts, setFOpts] = useState([]);
  const [fS, setFS] = useState({ c: 0, t: 0 });
  const [fPool, setFPool] = useState([]);
  const [fFb, setFFb] = useState(null);
  const [fSel, setFSel] = useState(null);
  const [vBox, setVBox] = useState(`0 0 ${W} ${H}`);
  const [zoomed, setZoomed] = useState(false);
  const iRef = useRef(null);
  const tmr = useRef(null);

  const t = T[lang];
  const gn = useCallback(
    (id) => {
      return lang === "es" && ES[id] ? ES[id].name : COUNTRIES[id]?.name;
    },
    [lang],
  );

  const gc = (id) =>
    lang === "es" && ES[id] ? ES[id].capital : COUNTRIES[id]?.capital;

  const findC = (g) => {
    const lo = g.toLowerCase().trim(),
      no = norm(g.trim());
    return EN_AL[lo] || EN_AL[no] || ES_AL[lo] || ES_AL[no] || null;
  };
  const findCap = (g, tid) => {
    const no = norm(g.trim()),
      s = (x) => x.replace(/[^a-z]/g, "");
    const en = norm(COUNTRIES[tid]?.capital || ""),
      es = norm(ES[tid]?.capital || "");
    return no === en || no === es || s(no) === s(en) || s(no) === s(es);
  };

  useEffect(() => {
    fetch(TOPO_URL)
      .then((r) => r.json())
      .then((d) => {
        setGeo(decodeTopo(d, "countries"));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (run && tDur > 0) {
      tmr.current = setInterval(() => {
        setTLeft((p) => {
          if (p <= 1) {
            clearInterval(tmr.current);
            setRun(false);
            return 0;
          }
          return p - 1;
        });
      }, 1000);
      return () => clearInterval(tmr.current);
    }
  }, [run, tDur]);

  useEffect(() => {
    if (scr !== "countries" || !run || !inp.trim()) return;
    const h = setTimeout(() => {
      const id = findC(inp);
      if (id && COUNTRIES[id] && !guessed.has(id)) {
        setGuessed((p) => {
          const n = new Set(p);
          n.add(id);
          return n;
        });
        setLast(gn(id));
        setStreak((s) => s + 1);
        setFlash("ok");
        setTimeout(() => setFlash(null), 700);
        setInp("");
      }
    }, 380);
    return () => clearTimeout(h);
  }, [inp, scr, run, guessed, lang, gn]);

  useEffect(() => {
    if (scr !== "capitals" || !run || !inp.trim() || !cQ || cFb) return;
    const h = setTimeout(() => {
      if (findCap(inp, cQ)) {
        setCS((p) => ({ c: p.c + 1, t: p.t + 1 }));
        setCFb("ok");
        setInp("");
        setTimeout(() => {
          setCFb(null);
          const ni = cPool.indexOf(cQ) + 1;
          if (ni < cPool.length) setCQ(cPool[ni]);
          else setRun(false);
        }, 800);
      }
    }, 500);
    return () => clearTimeout(h);
  }, [inp, scr, run, cQ, cFb, cPool, lang]);

  const proj = useMemo(
    () => (geo ? d3.geoNaturalEarth1().fitSize([W, H], geo) : null),
    [geo],
  );
  const pathGen = useMemo(
    () => (proj ? d3.geoPath().projection(proj) : null),
    [proj],
  );

  const centroids = useMemo(() => {
    if (!pathGen || !geo) return {};
    const out = {};
    geo.features.forEach((f) => {
      const c = pathGen.centroid(f);
      if (c && isFinite(c[0]) && isFinite(c[1])) out[f.id] = c;
    });
    return out;
  }, [pathGen, geo]);

  const handleMapClick = useCallback(
    (e, fId) => {
      e.stopPropagation();
      if (zoomed) {
        setVBox(`0 0 ${W} ${H}`);
        setZoomed(false);
        return;
      }
      const c = centroids[fId];
      if (!c) return;
      const zf = 0.4;
      const fw = W * zf,
        fh = H * zf;
      const vx = Math.max(0, Math.min(c[0] - fw / 2, W - fw));
      const vy = Math.max(0, Math.min(c[1] - fh / 2, H - fh));
      setVBox(`${vx} ${vy} ${fw} ${fh}`);
      setZoomed(true);
    },
    [zoomed, centroids],
  );

  const resetZoom = useCallback(() => {
    setVBox(`0 0 ${W} ${H}`);
    setZoomed(false);
  }, []);

  const start = (m) => {
    setGuessed(new Set());
    setInp("");
    setTLeft(tDur);
    setRun(true);
    setLast(null);
    setStreak(0);
    setHints(3);
    setFlash(null);
    setCS({ c: 0, t: 0 });
    setFS({ c: 0, t: 0 });
    setCFb(null);
    setFFb(null);
    setFSel(null);
    setVBox(`0 0 ${W} ${H}`);
    setZoomed(false);
    if (m === "capitals") {
      const p = Object.keys(COUNTRIES).sort(() => Math.random() - 0.5);
      setCPool(p);
      setCQ(p[0]);
    }
    if (m === "flags") {
      const p = Object.keys(COUNTRIES).sort(() => Math.random() - 0.5);
      setFPool(p);
      nfq(p, 0);
    }
    setScr(m);
    setTimeout(() => iRef.current?.focus(), 100);
  };

  const nfq = (pool, idx) => {
    if (idx >= pool.length) return;
    const c = pool[idx],
      o = Object.keys(COUNTRIES)
        .filter((k) => k !== c)
        .sort(() => Math.random() - 0.5)
        .slice(0, 3);
    setFQ(c);
    setFOpts([c, ...o].sort(() => Math.random() - 0.5));
    setFSel(null);
    setFFb(null);
  };

  const skipCap = () => {
    if (!cQ || cFb) return;
    setCS((p) => ({ c: p.c, t: p.t + 1 }));
    setCFb(gc(cQ));
    setInp("");
    setTimeout(() => {
      setCFb(null);
      const ni = cPool.indexOf(cQ) + 1;
      if (ni < cPool.length) setCQ(cPool[ni]);
      else setRun(false);
    }, 2000);
  };

  const pickFlag = (id) => {
    if (fFb) return;
    setFSel(id);
    const ok = id === fQ;
    setFS((p) => ({ c: p.c + (ok ? 1 : 0), t: p.t + 1 }));
    setFFb(ok ? "ok" : fQ);
    setTimeout(
      () => {
        const ni = fPool.indexOf(fQ) + 1;
        if (ni < fPool.length) nfq(fPool, ni);
        else setRun(false);
      },
      ok ? 800 : 2000,
    );
  };

  const useHint = () => {
    if (hints <= 0 || scr !== "countries") return;
    const u = Object.keys(COUNTRIES).filter((id) => !guessed.has(id));
    if (!u.length) return;
    const r = u[Math.floor(Math.random() * u.length)];
    setHints((h) => h - 1);
    setLast(`💡 ${gn(r)}`);
    setGuessed((p) => {
      const n = new Set(p);
      n.add(r);
      return n;
    });
  };

  const quit = () => {
    setRun(false);
    clearInterval(tmr.current);
  };
  const done = guessed.size === total;
  const pct = Math.round((guessed.size / total) * 100);

  const LangBtn = ({ sm }) => (
    <button
      onClick={() => setLang((l) => (l === "en" ? "es" : "en"))}
      className={`${sm ? "px-2.5 py-1 text-xs" : "px-3.5 py-1.5 text-sm"} rounded-full border border-white/20 bg-white/5 text-slate-200 font-bold cursor-pointer hover:bg-white/10 flex items-center gap-1.5 transition-colors`}
    >
      {lang === "en" ? "🇪🇸" : "🇬🇧"} {t.lng}
    </button>
  );

  const MapView = ({ compact }) => {
    if (!geo || !pathGen)
      return <div className="text-slate-400 text-center py-6">Loading...</div>;
    return (
      <div className="relative">
        <svg
          viewBox={vBox}
          className="w-full rounded-xl cursor-pointer"
          style={{
            background: "#0f172a",
            maxHeight: compact ? "64vh" : "80vh",
            transition: "all 0.5s ease",
          }}
        >
          <rect width={W} height={H} fill="#0f172a" />
          {geo.features.map((f) => {
            const d = pathGen(f);
            if (!d) return null;
            const g = guessed.has(f.id),
              hl = scr === "capitals" && cQ === f.id;
            return (
              <path
                key={f.id}
                d={d}
                fill={hl ? "#facc15" : g ? "#22c55e" : "#334155"}
                stroke="#0f172a"
                strokeWidth={0.5}
                opacity={hl ? 1 : g ? 0.9 : 0.7}
                style={{ transition: "fill 0.3s" }}
                onClick={(e) => handleMapClick(e, f.id)}
                className="hover:opacity-100"
              />
            );
          })}
        </svg>
        {zoomed && (
          <button
            onClick={resetZoom}
            className="absolute top-2 right-2 px-2.5 py-1 rounded-lg bg-black/60 text-white text-xs font-semibold cursor-pointer border border-white/20 hover:bg-black/80 backdrop-blur-sm transition-colors"
          >
            ✕ {t.zoomOut}
          </button>
        )}
      </div>
    );
  };

  const borderColor = (f) =>
    f === "ok"
      ? "border-green-500"
      : f === "bad"
        ? "border-red-500"
        : f === "dup"
          ? "border-amber-500"
          : "border-slate-700";

  if (loading)
    return (
      <div className="min-h-screen w-full bg-slate-900 flex items-center justify-center text-white font-sans">
        <div className="text-center">
          <div className="text-5xl mb-4">🌍</div>
          <div className="text-xl font-semibold">Loading GeoMaster...</div>
        </div>
      </div>
    );

  if (scr === "menu")
    return (
      <div className="min-h-screen w-full bg-gradient-to-br from-slate-900 to-slate-800 flex items-center justify-center font-sans p-4">
        <div className="w-full max-w-xl text-center">
          <div className="flex justify-end mb-2">
            <LangBtn />
          </div>
          <div className="text-6xl mb-2">🌍</div>
          <h1 className="text-white text-4xl font-extrabold tracking-tight mb-1">
            {t.title}
          </h1>
          <p className="text-slate-400 text-base mb-8">{t.sub}</p>
          <div className="flex flex-col gap-3 mb-8">
            {[
              {
                m: "countries",
                i: "🗺️",
                n: t.countries,
                d: t.countriesD,
                c: "text-green-500",
              },
              {
                m: "capitals",
                i: "🏛️",
                n: t.capitals,
                d: t.capitalsD,
                c: "text-yellow-400",
              },
              {
                m: "flags",
                i: "🏁",
                n: t.flags,
                d: t.flagsD,
                c: "text-blue-500",
              },
            ].map((g) => (
              <button
                key={g.m}
                onClick={() => start(g.m)}
                className="bg-white/5 border border-white/10 rounded-2xl p-5 cursor-pointer flex items-center gap-4 text-left transition-all hover:bg-white/10 hover:border-white/20 active:scale-[0.98]"
              >
                <span className="text-4xl">{g.i}</span>
                <div className="flex-1 min-w-0">
                  <div className="text-white text-lg font-bold">{g.n}</div>
                  <div className="text-slate-400 text-sm mt-0.5">{g.d}</div>
                </div>
                <span className={`${g.c} text-xl`}>→</span>
              </button>
            ))}
          </div>
          <div className="bg-white/5 rounded-xl p-4 border border-white/10">
            <div className="text-slate-400 text-xs font-semibold uppercase tracking-widest mb-3">
              {t.timer}
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {TIMERS.map((p) => (
                <button
                  key={p.v}
                  onClick={() => setTDur(p.v)}
                  className={`px-4 py-2 rounded-lg text-sm font-semibold cursor-pointer transition-colors ${tDur === p.v ? "bg-blue-500 text-white" : "bg-white/10 text-slate-400 hover:bg-white/15"}`}
                >
                  {p[lang]}
                </button>
              ))}
            </div>
          </div>
          <p className="text-slate-600 text-xs mt-4">
            {total} {t.disc}
          </p>
        </div>
      </div>
    );

  const Header = ({ icon, stat, color }) => (
    <>
      <div className="flex items-center justify-between px-3 py-2 bg-black/30 flex-wrap gap-1.5">
        <button
          onClick={() => {
            quit();
            setScr("menu");
          }}
          className="bg-transparent border-none text-slate-400 cursor-pointer text-sm font-semibold hover:text-white transition-colors"
        >
          ← {t.menu}
        </button>
        <div className="flex items-center gap-3 flex-wrap">
          <span className="text-sm text-slate-400">
            {icon} {stat}
          </span>
          {scr === "countries" && streak > 1 && (
            <span className="text-sm text-amber-500">
              🔥 {streak} {t.streak}
            </span>
          )}
          {tDur > 0 && (
            <span
              className={`text-sm font-bold tabular-nums ${tLeft < 60 ? "text-red-500" : tLeft < 120 ? "text-amber-500" : color}`}
            >
              ⏱ {fmt(tLeft)}
            </span>
          )}
        </div>
        <div className="flex gap-1.5 items-center">
          <LangBtn sm />
          {scr === "countries" && (
            <button
              onClick={useHint}
              disabled={hints <= 0}
              className={`px-2.5 py-1 rounded-lg text-xs font-semibold text-white ${hints > 0 ? "bg-violet-600 cursor-pointer hover:bg-violet-500" : "bg-slate-700 cursor-default opacity-50"}`}
            >
              💡 {t.hint} ({hints})
            </button>
          )}
          <button
            onClick={quit}
            className="px-2.5 py-1 rounded-lg text-xs font-semibold text-white bg-red-600 cursor-pointer hover:bg-red-500"
          >
            {t.give}
          </button>
        </div>
      </div>
      <div className="h-1 bg-slate-800">
        <div
          className="h-1 rounded-sm transition-all duration-500"
          style={{
            background:
              scr === "countries"
                ? "#22c55e"
                : scr === "capitals"
                  ? "#facc15"
                  : "#3b82f6",
            width: `${scr === "countries" ? pct : scr === "capitals" ? (cPool.length ? ((cPool.indexOf(cQ) + 1) / cPool.length) * 100 : 0) : fPool.length ? ((fPool.indexOf(fQ) + 1) / fPool.length) * 100 : 0}%`,
          }}
        />
      </div>
    </>
  );

  const End = ({ emoji, title, sub, btnClass, retry }) => (
    <div className="text-center py-4">
      <div className="text-5xl mb-2">{emoji}</div>
      <div className="text-xl font-extrabold text-white mb-1">{title}</div>
      <div className="text-slate-400 text-base mb-4">{sub}</div>
      <div className="flex gap-2 justify-center flex-wrap">
        <button
          onClick={retry}
          className={`px-5 py-2.5 rounded-xl font-bold cursor-pointer text-sm ${btnClass}`}
        >
          {t.again}
        </button>
        <button
          onClick={() => setScr("menu")}
          className="px-5 py-2.5 rounded-xl font-bold cursor-pointer text-sm bg-slate-700 text-white hover:bg-slate-600"
        >
          {t.back}
        </button>
      </div>
    </div>
  );

  // COUNTRIES
  if (scr === "countries")
    return (
      <div className="min-h-screen w-full bg-slate-900 font-sans text-white">
        <Header
          icon="🗺️"
          stat={
            <>
              <strong>{guessed.size}</strong>/{total}
            </>
          }
          color="text-green-500"
        />
        <div className="px-2 pt-1">
          <MapView compact />
        </div>
        <div className="px-3 pt-4 pb-4 max-w-xl mx-auto w-full">
          {run && !done ? (
            <>
              <input
                ref={iRef}
                value={inp}
                onChange={(e) => setInp(e.target.value)}
                placeholder={t.ph}
                className={`w-full px-4 py-3 rounded-xl bg-slate-800 text-white text-base outline-none transition-colors border-2 ${borderColor(flash)} placeholder:text-slate-500`}
              />
              {last && (
                <p className="text-center mt-1.5 text-green-400 text-sm font-semibold">
                  ✓ {last}
                </p>
              )}
              {flash === "dup" && (
                <p className="text-center mt-1 text-amber-500 text-sm">
                  {t.dup}
                </p>
              )}
            </>
          ) : (
            <>
              <End
                emoji={done ? "🎉" : "⏱️"}
                title={done ? t.wow : t.up}
                sub={
                  <>
                    {t.named}{" "}
                    <strong className="text-green-500">{guessed.size}</strong>{" "}
                    {t.of} {total} ({pct}%)
                  </>
                }
                btnClass="bg-green-500 text-slate-900 hover:bg-green-400"
                retry={() => start("countries")}
              />
              {!done && (
                <details className="mt-2 text-left">
                  <summary className="text-slate-400 cursor-pointer text-sm">
                    {t.miss} ({total - guessed.size})
                  </summary>
                  <div className="flex flex-wrap gap-1.5 mt-2">
                    {Object.entries(COUNTRIES)
                      .filter(([id]) => !guessed.has(id))
                      .map(([id, c]) => (
                        <span
                          key={id}
                          className="bg-slate-800 px-2 py-1 rounded-md text-xs text-slate-400 flex items-center gap-1"
                        >
                          <img
                            src={`https://flagcdn.com/w20/${c.iso2}.png`}
                            alt=""
                            className="w-4 h-3"
                          />
                          {gn(id)}
                        </span>
                      ))}
                  </div>
                </details>
              )}
            </>
          )}
        </div>
      </div>
    );

  // CAPITALS
  if (scr === "capitals") {
    const dn = !run && cS.t > 0,
      cc = cQ ? COUNTRIES[cQ] : null;
    return (
      <div className="min-h-screen w-full bg-slate-900 font-sans text-white">
        <Header
          icon="🏛️"
          stat={
            <>
              <strong>{cS.c}</strong>/{cS.t}
            </>
          }
          color="text-yellow-400"
        />
        <div className="px-2 pt-1">
          <MapView compact />
        </div>
        <div className="px-3 pt-4 pb-4 max-w-xl mx-auto w-full text-center">
          {!dn && cc && run ? (
            <>
              <div className="mb-2 flex items-center justify-center gap-2 flex-wrap">
                <img
                  src={`https://flagcdn.com/w40/${cc.iso2}.png`}
                  alt=""
                  className="w-10 h-auto rounded inline-block"
                />
                <span className="text-base font-bold">
                  {t.wcap} <span className="text-yellow-400">{gn(cQ)}</span>?
                </span>
              </div>
              <div className="flex gap-2 items-stretch">
                <input
                  ref={iRef}
                  value={inp}
                  onChange={(e) => setInp(e.target.value)}
                  placeholder={t.capPh}
                  className={`flex-1 min-w-0 px-4 py-3 rounded-xl bg-slate-800 text-white text-base outline-none transition-colors border-2 ${cFb === "ok" ? "border-green-500" : cFb ? "border-red-500" : "border-slate-700"} placeholder:text-slate-500`}
                />
                <button
                  onClick={skipCap}
                  className="px-4 rounded-xl border border-slate-600 bg-transparent text-slate-400 cursor-pointer text-sm font-semibold hover:text-white hover:border-slate-400 transition-colors shrink-0"
                >
                  {t.skip} →
                </button>
              </div>
              {cFb === "ok" && (
                <p className="text-green-500 mt-2 font-semibold">✓ {t.ok}</p>
              )}
              {cFb && cFb !== "ok" && (
                <p className="text-red-500 mt-2 font-semibold">
                  ✗ {t.ans} <strong>{cFb}</strong>
                </p>
              )}
            </>
          ) : (
            <End
              emoji={cS.t && cS.c / cS.t > 0.8 ? "🏆" : "📊"}
              title={t.res}
              sub={
                <>
                  <strong className="text-yellow-400">{cS.c}</strong> {t.cof}{" "}
                  <strong>{cS.t}</strong> (
                  {cS.t ? Math.round((cS.c / cS.t) * 100) : 0}%)
                </>
              }
              btnClass="bg-yellow-400 text-slate-900 hover:bg-yellow-300"
              retry={() => start("capitals")}
            />
          )}
        </div>
      </div>
    );
  }

  // FLAGS
  if (scr === "flags") {
    const dn = !run && fS.t > 0,
      cc = fQ ? COUNTRIES[fQ] : null;
    return (
      <div className="min-h-screen w-full bg-slate-900 font-sans text-white">
        <Header
          icon="🏁"
          stat={
            <>
              <strong>{fS.c}</strong>/{fS.t}
            </>
          }
          color="text-blue-500"
        />
        <div className="px-4 py-4 max-w-lg mx-auto w-full text-center">
          {!dn && cc && run ? (
            <>
              <p className="text-xs text-slate-400 font-semibold uppercase tracking-widest mb-4">
                {t.wflag}
              </p>
              <div className="inline-block rounded-xl overflow-hidden shadow-2xl mb-5 border-2 border-white/10">
                <img
                  src={`https://flagcdn.com/w320/${cc.iso2}.png`}
                  alt="Flag"
                  className="block h-auto"
                  style={{ maxWidth: "min(280px, 60vw)" }}
                  onError={(e) => {
                    e.target.src = `https://flagcdn.com/w160/${cc.iso2}.png`;
                  }}
                />
              </div>
              <div className="grid grid-cols-2 gap-2.5">
                {fOpts.map((id) => {
                  const isOk = fFb && id === fQ,
                    isW = fFb && fSel === id && id !== fQ;
                  return (
                    <button
                      key={id}
                      onClick={() => pickFlag(id)}
                      className={`px-3 py-3.5 rounded-xl text-sm font-semibold transition-all ${isOk ? "border-2 border-green-500 bg-green-500/15 text-white" : isW ? "border-2 border-red-500 bg-red-500/15 text-white" : "border-2 border-white/10 bg-white/5 text-white hover:bg-white/10 hover:border-white/20"} ${fFb ? "cursor-default" : "cursor-pointer active:scale-95"}`}
                    >
                      {gn(id)}
                    </button>
                  );
                })}
              </div>
              {fFb === "ok" && (
                <p className="text-green-500 mt-3 font-semibold text-base">
                  ✓ {t.ok}
                </p>
              )}
              {fFb && fFb !== "ok" && (
                <p className="text-red-500 mt-3 font-semibold text-base">
                  ✗ {t.was}{" "}
                  <strong className="text-green-500">{gn(fFb)}</strong>
                </p>
              )}
            </>
          ) : (
            <End
              emoji={fS.t && fS.c / fS.t > 0.8 ? "🏆" : "📊"}
              title={t.fres}
              sub={
                <>
                  <strong className="text-blue-500">{fS.c}</strong> {t.cof}{" "}
                  <strong>{fS.t}</strong> (
                  {fS.t ? Math.round((fS.c / fS.t) * 100) : 0}%)
                </>
              }
              btnClass="bg-blue-500 text-white hover:bg-blue-400"
              retry={() => start("flags")}
            />
          )}
        </div>
      </div>
    );
  }
  return null;
}
